import React, { useEffect, useRef, useState } from "react"
import { gsap } from "gsap"

import Search from "./Search"
import Splash from "./Splash"
import List from "../components/List"
import HeroVideo from "../components/Timeline/HeroVideo"
import EmployeeCard from "../components/EmployeeCard"
import Music from "../components/Music"
import { ReactComponent as FiveYearRibbon } from "../images/ribbons/5year.svg"

import { years } from "../services/timelineService"

const people = require("../fixtures/people.json")
function Test() {
  // Test vars
  const [testComponent, setTestComponent] = useState("List")
  const testTl = gsap.timeline()

  // List vars
  const [currentSegment, setCurrentSegment] = useState(0)
  const animateList = () => {
    gsap.to(".anniversary-list--anim", {
      opacity: 1,
      duration: 2,
      ease: "power1.inOut",
    })
  }

  // HeroVideo Vars
  const handleHeroLoad = () => {
    console.log("hero loaded")
  }
  const handleHeroComplete = () => {
    console.log("hero complete")
  }

  // Search Vars
  // const testList = people.sort((a, b) => {
  //   if(a.lastName > b.lastName){
  //     return 1
  //   } else if(a.lastName < b.lastName){
  //     return -1
  //   } else {
  //     if(a.firstName > b.firstName){
  //       return 1
  //     } else if(a.firstName < b.firstName){
  //       return -1
  //     } else {
  //       return 0
  //     }
  //   }
  // })

  // Employee Card Vars

  // Music Vars
  const [musicPlaying, setMusicPlaying] = useState(false)

  return (
    <div>
      <button onClick={() => setTestComponent("HeroVideo")}>HeroVideo</button>
      <button
        onClick={() => {
          setTestComponent("List")
          animateList()
        }}
      >
        List
      </button>
      <button onClick={() => setTestComponent("Splash")}>Splash</button>
      <button onClick={() => setTestComponent("Search")}>Search</button>
      <button onClick={() => setTestComponent("EmployeeCard")}>
        EmployeeCard
      </button>
      <button onClick={() => setTestComponent("Music")}>Music</button>
      {/* {testComponent === "HeroVideo" && (
        <HeroVideo
          currentSegment={currentSegment}
          handleHeroComplete={handleHeroComplete}
          handleHeroLoad={handleHeroLoad}
        />
      )} */}
      {/* {testComponent === "List" && <List list={people}/>}
      {testComponent === "Splash" && <Splash />}
      {testComponent === "Search" && <Search />}
      {testComponent === "EmployeeCard" && <EmployeeCard />}
      {testComponent === "Music" && <Music currentSegment={currentSegment} musicPlaying={musicPlaying} setMusicPlaying={setMusicPlaying}/>} */}
      <div className='card' style={{opacity: 1}}>
        <div className='card--anniversary-year'>
        <div className='card--anniversary-year__ribbon'>
          <FiveYearRibbon width='100%' height='100%' />
          </div>
        <div className='card--anniversary-year__copy'>
          <p>{2020 - years[currentSegment] - 1} Year Service Awards</p>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Test
